import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getNextStep, getPrevStep } from '../../../utils/steps';
import { ELandingType } from '../../../types/landingType';
import { ILogger, TError, TMeta } from '@cian/logger/shared';
import { EActivateInsuranceStep } from '../../../types/activateInsurance/step';

interface IErrorPayload {
  logger: ILogger;
  error: TError;
  extra?: TMeta;
}

export interface IStepsSlice {
  activeStep: EActivateInsuranceStep;
  steps: EActivateInsuranceStep[];
}

const initialState: IStepsSlice = {
  activeStep: EActivateInsuranceStep.Unexpected,
  steps: [EActivateInsuranceStep.Unexpected],
};

const stepsConfigurationSlice = createSlice({
  name: 'steps',
  initialState,
  reducers: {
    setStepsConfiguration(state, action: PayloadAction<IStepsSlice>) {
      state.steps = action.payload.steps;
      state.activeStep = action.payload.activeStep;
    },
    goToNextStep(state) {
      state.activeStep = getNextStep(
        state.steps,
        EActivateInsuranceStep.Unexpected,
        ELandingType.ActivateInsurance,
        state.activeStep,
      ) as EActivateInsuranceStep;
    },
    goToPrevStep(state) {
      state.activeStep = getPrevStep(
        state.steps,
        EActivateInsuranceStep.Unexpected,
        ELandingType.ActivateInsurance,
        state.activeStep,
      ) as EActivateInsuranceStep;
    },
    goToErrorStep: (state, action: PayloadAction<IErrorPayload>) => {
      const { logger, error, extra } = action.payload;
      logger.error(error, extra);

      state.activeStep = EActivateInsuranceStep.Error;
    },
  },
});

export const {
  reducer: stepsConfigurationReducer,
  actions: { goToNextStep, goToPrevStep, goToErrorStep, setStepsConfiguration },
} = stepsConfigurationSlice;
